import { Component, EventEmitter, Output, Input} from '@angular/core';
import { RISCommonModule } from "../../ris.common.module";

export type MessageLevel = "Warning" | "Error" | "Info";

/**
 * UnauthorizedPopupComponent displays a popup when the user's session has expired or they are unauthorized.
 * It provides a message and an OK button to close the popup.
 */
@Component({
  selector: 'cp-unauthorized-popup',
  template: `
    <cp-info-popup (close)="close.emit()" [customLabel]="customTitle" [level]="level" [messagesHeightChanges]="true">
	    <div class="popup-text">
        {{customPopupText | cpMessageTranslate}} 
        <div class="url">
          {{errorUrl ? "(" + errorUrl + ")" : ''}}
        </div>
      </div>
      <cp-popup-buttons-ok class="popup-buttons" (ok)="close.emit()"></cp-popup-buttons-ok>
    </cp-info-popup>
  `,
  styles: [`
    .url {
      word-break: break-all;
      white-space: normal;
      overflow-wrap: anywhere;
      max-width: 100%;
      display: inline-block;
      opacity: 0.7;
      margin-top: 10px;
    }
  `],
  standalone: true,
  imports: [ RISCommonModule ]
})
export class UnauthorizedPopupComponent {
  @Output() close = new EventEmitter<void>();
  @Input() errorUrl?: string;

  public level: MessageLevel = "Error";
  // Custom title will be translated using cpTitleTranslate pipe (within <cp-info-popup), the item is InsufficientPrivileges.Title
  public customTitle = 'InsufficientPrivileges';
  // Custom popup text will be translated using cpMessageTranslate pipe, the item is InsufficientPrivileges.Message
  public customPopupText = 'InsufficientPrivileges';
}
